// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","game":"App_game__wftui","game--easy":"App_game--easy__wnXz7","game--normal":"App_game--normal__-RlVp","game--hard":"App_game--hard__5ozTl"};